/**
 * Draft réservation après acceptation devis (créneau + paiement uniquement).
 */
export function buildQuoteAcceptBookingDraft(appointment, quote) {
  if (!appointment || !quote) return null;

  const fullName = appointment.customerName || appointment.customer_name || '';
  const nameParts = fullName.trim().split(/\s+/).filter(Boolean);
  const firstName = nameParts[0] || '';
  const lastName = nameParts.slice(1).join(' ') || '';

  const addressRaw = appointment.customerAddress || appointment.customer_address || '';
  const addressMatch = addressRaw.match(/^(.*?),\s*(\d{5})\s+(.+)$/);
  const streetLine = addressMatch ? addressMatch[1].trim() : addressRaw;
  const postcode = addressMatch ? addressMatch[2] : '';
  const city = addressMatch ? addressMatch[3].trim() : '';

  const quoteHt = Number(quote.total_ht ?? quote.price) || 0;
  const vatRate = Number(quote.vat_rate) || 20;
  const serviceNode = appointment.service || appointment.Service;
  const problemNode = serviceNode?.problem;
  const equipmentNode = problemNode?.equipment;
  const categoryNode = equipmentNode?.category;
  const hasSiret = Boolean(`${appointment.siret || ''}`.replace(/\s/g, '').match(/^\d{14}$/));

  return {
    fromAcceptedQuote: true,
    quoteReference: quote.reference,
    sourceAppointmentId: appointment.id,
    quoteId: quote.id,
    category: categoryNode
      ? { id: categoryNode.id, name: categoryNode.name }
      : undefined,
    equipment: equipmentNode
      ? { id: equipmentNode.id, name: equipmentNode.name }
      : undefined,
    problemId: problemNode?.id || null,
    problemName: appointment.problemName || problemNode?.name || '',
    description: appointment.notes || '',
    service: {
      id: serviceNode?.id,
      name: serviceNode?.name || appointment.serviceType || appointment.service_type || 'Service',
      basePrice: quoteHt,
      price: quoteHt,
      PricingModel: 'prix fixe',
      estimatedDuration: serviceNode?.estimatedDuration || 60,
      tva: vatRate,
      TVA: vatRate,
      fromAcceptedQuote: true,
    },
    // Force sélection de date (pas d'urgence)
    urgency: {
      id: 'tomorrow',
      name: 'Choisir une date',
      label: 'Choisir une date',
      priceMultiplier: 1,
    },
    customerType: hasSiret ? 'business' : 'individual',
    siret: appointment.siret || '',
    fullName,
    firstName,
    lastName,
    email: appointment.customerEmail || appointment.customer_email || '',
    phone: appointment.customerPhone || appointment.customer_phone || '',
    streetLine,
    postcode,
    city,
    address: addressRaw,
    lat: appointment.customerLatitude ?? appointment.customer_latitude ?? null,
    lng: appointment.customerLongitude ?? appointment.customer_longitude ?? null,
    location: {
      lat: appointment.customerLatitude ?? appointment.customer_latitude ?? null,
      lng: appointment.customerLongitude ?? appointment.customer_longitude ?? null,
    },
    acceptTerms: true,
    acceptRGPD: true,
    createAccount: false,
  };
}
